import {message} from 'antd'
import {unMarkPrintedOrder} from "../../../../services/api/3dApi"

export default async function (orderId) {
    try {
        const {data: response} = await unMarkPrintedOrder(orderId)

        const {success, error} = response

        if (!success) {
            throw new Error(error)
        }

        message.success('Thành công')
    } catch (e) {
        message.error(e.message, 3)
    }
}
